<template>
  <div id="app-root">
    <div v-if="globalError" class="app-crash-fallback">
      <div class="app-crash-card">
        <i class="bi bi-exclamation-triangle-fill app-crash-icon"></i>
        <h3 class="app-crash-title">Terjadi Kendala Teknis</h3>
        <p class="app-crash-desc">
          Halaman tidak dapat ditampilkan dengan baik. Silakan muat ulang halaman untuk memperbarui data terbaru.
        </p>
        <div class="app-crash-actions">
          <button type="button" class="btn btn-primary" @click="reloadApp">
            <i class="bi bi-arrow-clockwise me-1"></i> Muat Ulang Halaman
          </button>
          <button type="button" class="btn btn-outline-secondary" @click="resetError">
            <i class="bi bi-arrow-left me-1"></i> Coba Lanjutkan
          </button>
        </div>
      </div>
    </div>
    <router-view v-else />
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      globalError: null,
    };
  },
  errorCaptured(err) {
    console.error('[App Root Error Boundary]', err);
    this.globalError = err;
    return false;
  },
  methods: {
    reloadApp() {
      this.globalError = null;
      window.location.reload();
    },
    resetError() {
      this.globalError = null;
    },
  },
};
</script>

<style>
.app-crash-fallback {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 1.5rem;
  background-color: var(--bg-base, #f8fafc);
}

.app-crash-card {
  max-width: 480px;
  width: 100%;
  padding: 2rem;
  background-color: var(--bg-surface, #ffffff);
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-xl, 16px);
  box-shadow: var(--shadow-md, 0 4px 12px rgba(0, 0, 0, 0.08));
  text-align: center;
}

.app-crash-icon {
  font-size: 2.5rem;
  color: var(--accent, #f05008);
  margin-bottom: 1rem;
  display: inline-block;
}

.app-crash-title {
  font-family: var(--font-sans);
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--text-primary, #0f172a);
  margin-bottom: 0.5rem;
}

.app-crash-desc {
  font-size: 0.875rem;
  color: var(--text-secondary, #475569);
  line-height: 1.6;
  margin-bottom: 1.5rem;
}

.app-crash-actions {
  display: flex;
  gap: 0.75rem;
  justify-content: center;
  flex-wrap: wrap;
}
</style>
